blue.ready('contentSlider_activeState', '.contentSlider', slider => {
	const slides = [...slider.querySelectorAll('.contentSlide')]
	const locator = slider.querySelector('.contentSlider-locator')
	const track = slider.querySelector('.contentSlider-sliderTrack-inner')
	const navigator = slider.querySelector('.contentSlider-nav')
	const navs = [...navigator.querySelectorAll('.contentNav-nav')]
	let fresh = true
	let visible
	let adjust
	let offset
	let pos

	const init = () => {
		if (blue.prop.media.md.matches) {
			//get number of visible slides from css variables
			visible = Math.round(getComputedStyle(slides[0]).getPropertyValue('--visible'))
			//used for mobile when we have 1 1/4 slides visible (compensates for the 1/4 of a slide)
			adjust = (1 - (getComputedStyle(slides[0]).getPropertyValue('--visible') - 1) / 2)
			//width of a single slide (how far the track is moved in a single navigation)
			offset = slides[0].offsetWidth
			//initial position of a slide
			pos = 0

			//init the navigation (show if number of slides is greater than are visible on screen)
			if (
				(blue.prop.media.default.matches && slides.length > 4) ||
				(blue.prop.media.md.matches && slides.length > 3)) {
				navs[1].classList.add('is-active')
			}
			else {
				navigator.style.display = 'none'
			}
			reset(true)


			if (visible === 4 && slides.length <= 4) {
				navs.forEach(nav => {
					nav.style.display = 'none'
				})
			} else if (visible < slides.length) {
				navs.forEach(nav => {
					nav.style.display = 'flex'
				})
			}

			if (fresh) track.style.transform = `translateX(0)`
			//select the first slide 1s after page load IF the user hasnt clicked on a slide yet
			setTimeout(() => {
				if (fresh) {
					toggle.apply(slides[0], [{}])
					fresh = false
				}
			}, 1000)
		}
	}

	//close the slides and remove the locator line and optionaly the track
	const reset = (resetTrack = false) => {
		if (blue.prop.media.md.matches) {
			slider.classList.remove('is-active')
			slides.forEach(slide => slide.classList.remove('is-active'))
			locator.classList.remove('is-active')
			locator.style.left = 0
			if (resetTrack) {
				track.style.transform = `translateX(0)`
			}
		}
	}

	//open close slides
	const toggle = function (e) {
		if(!this.classList.contains('is-active')){
			if (blue.prop.media.md.matches) {
				if (blue.meth.checkVisible(this, "x")) {
					fresh = false
					let sibs = slides.filter(item => item != this)
					// if (this.classList.contains('is-active')) {
					// 	slider.classList.remove('is-active')
					// 	this.classList.remove('is-active')
					// 	reset()
					// }
					// else {
						slider.classList.add('is-active', 'is-disabled')
						this.classList.add('is-active')
						sibs.forEach(sib => sib.classList.remove('is-active'))
						locate(this)
						
					// }
				}
			}
			
		}
	}

	//move locator line to the correct active slide
	const locate = (slide) => {
		if (blue.prop.media.md.matches) {
			let left
			let transitionend

			if (locator.classList.contains('is-active')) {
				//find center of slide element to point locator at
				left = (slide.offsetLeft - slider.offsetLeft) + (slide.offsetWidth / 2)
				//adjust left value incase track has been transitioned
				left = left - (pos * offset)
				//function that is run after the height/padding is done transitioning
				transitionend = (e) => {
					if (e.propertyName == "height" || e.propertyName == "padding-top") {
						locator.style.left = `${left}px`
						locator.classList.add('is-active')
						locator.removeEventListener('transitionend', transitionend)
					}
				}
				locator.classList.remove('is-active')
				locator.addEventListener('transitionend', transitionend)
			}
			else {
				locator.classList.add('is-active')
				left = (slide.offsetLeft - slider.offsetLeft) + (slide.offsetWidth / 2)
				left = left - (pos * offset)
				if (!blue.prop.media.sm.matches && pos > 0) {
					left = left + (offset * (1 - adjust))
				}
				locator.style.left = `${left}px`
			}

		
			slider.classList.remove('is-disabled')

		}
	}

	//move track to correct space
	const navigate = function () {
		if (blue.prop.media.md.matches) {
			if (this.classList.contains('is-active')) {

				fresh = false
				let translate = 0
				if (this.classList.contains('contentNav-nav')) {
					pos =
						this.classList.contains('contentNav-nav--prev')
							? pos - 1
							: pos + 1
					//using arrows to navigate, reset active slide and locator line
					reset()
				}
				navs.forEach(nav => nav.classList.add('is-active'))
				if (pos >= slides.length - visible) {
					pos = slides.length - visible
					navs[1].classList.remove('is-active')
				}
				else if (pos <= 0) {
					pos = 0
					navs[0].classList.remove('is-active')
				}
				translate =
					blue.prop.media.sm.matches
						? pos * offset
						: pos > 0
							? ((pos - 1) * offset) + (offset * adjust)
							: 0
				track.style.transform = `translateX(-${translate}px)`
				//close track and reset locator line
			}
		}
	}

	slides.forEach(slide => slide.addEventListener('mousemove', toggle))
	navs.forEach(nav => nav.addEventListener('click', navigate))
	window.addEventListener('resize', init)
	window.addEventListener('orientationchange', init)
	init()
})